import React from "react";

const Footer = props => {
  console.log(props);
  return (
    <footer className="bg-brand-green-gradient px-3 py-2 text-white font-light mt-24 text-center text-sm ">
      &copy; Copyright 2020 Dismissed4Less by Agile Websites
    </footer>
  );
};

export default Footer;
